"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfirmEmailRegisterForm = void 0;
var LoginState_1 = require("@/pages/common/states/LoginState");
exports.defaultConfirmEmailRegisterForm = {
    firstname: '',
    lastname: '',
    salutation: LoginState_1.Salutation.MR,
    phoneCode: '852',
    phoneBody: '',
    password: '',
    passwordConfirm: '',
    subscribe: true,
    userId: '',
    code: '',
};
